import React from 'react';

const SvgChevronLeft = props => (
  <svg width={24} height={24} fill="none" {...props}>
    <path d="M15 6l-6 6 6 6" stroke="#000" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default SvgChevronLeft;
